import {SizeType} from "../sizeType";

export enum ListViewContentElementLayoutType {
  Row = 101,
  Column = 102,
  ActionsColumn = 103,
  Action = 104,
}

export const ListViewContentElementDefaultLabel = {
  [ListViewContentElementLayoutType.ActionsColumn]: 'Actions',
};

export const ListViewContentElementDefaultXSize = {
  [ListViewContentElementLayoutType.ActionsColumn]: SizeType.Sm,
};
